module.exports = __webpack_public_path__ + "static/media/car-drawing.8c4202a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cuiImg/car-drawing.png
// module id = 1758
// module chunks = 0